// extracted by mini-css-extract-plugin
export default {"root":"ProjectScheduleStats_root__aA-U8","stats":"ProjectScheduleStats_stats__YyQRl"};